<template>
  <div class="waterMarkPart">
    <sw-dialog :visible.sync="wmVisible" append-to-body :width="'900px'" center title="水印设置">

      <el-row :gutter="20" type="flex" justify="space-between" style="margin-bottom: 40px;">
        <el-col class="formLeft" :span="12">
          <el-form class="waterMarkForm"  ref="form" :model="form" label-width="120px">

            <el-form-item label="水印内容：">
              <sw-input v-model="textValue" type="textarea" size="small" :autosize="{ minRows: 2, maxRows: 4}"></sw-input>
            </el-form-item>

            <el-form-item >
              <el-row style="margin-bottom: 10px; display: flex; align-items: center" type="flex" justify="space-between">
                <el-col :span="16">
                  <el-checkbox v-model="form.dateChecked" size="small" >添加附件下载日期</el-checkbox>
                </el-col>
                <sw-button @click="bdbl.visible = true" type="text" >查询表单变量</sw-button>
              </el-row>
            </el-form-item>

            <el-row style="margin-bottom: 10px; display: flex; align-items: center">
              <el-col :span="14">
                <el-form-item label="字体：">
                  <sw-select v-model="form.fontFamily" disabled size="small" placeholder="请选择">
                      <sw-option
                        v-for="item in wmfOpt.fontFamilyOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </sw-option>
                    </sw-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="字号：" label-width="70px">
                  <sw-select v-model="form.fontSize" size="small" placeholder="请选择">
                      <sw-option
                        v-for="item in wmfOpt.fontSizeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </sw-option>
                    </sw-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="颜色：">
              <el-color-picker v-model="form.fontColor" @change="changeColorToRgb"></el-color-picker>
            </el-form-item>

            <el-form-item label="不透明度：">
              <el-slider v-model="form.opacity" show-input :min="0" :max="1" :step="0.1"></el-slider>
            </el-form-item>

            <el-form-item label="旋转：">
              <el-row :gutter="2" style="margin-bottom: 10px; display: flex; align-items: center" type="flex" justify="space-between">
                <el-col :span="12">
                  <sw-select v-model="angleValue.optValue" size="small" placeholder="请选择">
                    <sw-option
                      v-for="item in wmfOpt.rotationAngleOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </sw-option>
                  </sw-select>
                </el-col>

                <el-col :span="12">
                  <el-input-number v-show="angleValue.optValue === null" v-model="angleValue.cusValue" size="small" controls-position="right" :min="-180" :max="180" :step="1"></el-input-number>
                </el-col>

              </el-row>
            </el-form-item>

            <!-- <div class="pcItem">
              <el-form-item label="相对页面比例：">
                <el-input-number v-model="scaleValue" :disabled="!form.scaleChecked" :min="0.1" :max="2" :step="0.1" size="small"></el-input-number>
              </el-form-item>
              <el-checkbox v-model="form.scaleChecked" size="small" class="positionPart"></el-checkbox>
            </div> -->

            <div  class="mnItem">
              <el-form-item label="多行水印：">
                <sw-select v-model="markNumValue" size="small"  :disabled="!form.markNumChecked" placeholder="请选择">
                  <sw-option
                    v-for="item in wmfOpt.markNumberOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </sw-option>
                </sw-select>
              </el-form-item>
              <el-checkbox v-model="form.markNumChecked" size="small"  class="positionPart"></el-checkbox>
            </div>

            <!-- <el-row class="smallInputNumber" :gutter="5" style="margin-bottom: 10px; display: flex; align-items: center" type="flex" justify="space-between">
              <el-form-item label="水平对齐：">
                <el-col :span="9">
                    <sw-select v-model="form.horizontalAlignment.align" size="small" placeholder="请选择">
                      <sw-option
                        v-for="item in wmfOpt.horizontalAlignmentOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </sw-option>
                    </sw-select>
                </el-col>
                <el-col :span="8">
                    <el-input-number v-model="form.horizontalAlignment.alignNumber" size="small" controls-position="right" :min="-100" :max="100" :step="1"></el-input-number>
                </el-col>
                <el-col :span="7">
                  <sw-select v-model="form.horizontalAlignment.unit" size="small" placeholder="请选择">
                    <sw-option
                      v-for="item in wmfOpt.unitOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </sw-option>
                  </sw-select>
                </el-col>
              </el-form-item>
            </el-row>

            <el-row class="smallInputNumber"  :gutter="5" style="margin-bottom: 10px; display: flex; align-items: center" type="flex" justify="space-between">
              <el-form-item label="垂直对齐：">
                <el-col :span="9">
                    <sw-select v-model="form.verticalAlignment.align" size="small" placeholder="请选择">
                      <sw-option
                        v-for="item in wmfOpt.verticalAlignmentOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </sw-option>
                    </sw-select>
                </el-col>
                <el-col :span="8">
                    <el-input-number v-model="form.verticalAlignment.alignNumber" size="small" controls-position="right" :min="-100" :max="100" :step="1"></el-input-number>
                </el-col>
                <el-col :span="7">
                    <sw-select v-model="form.verticalAlignment.unit" size="small" placeholder="请选择">
                      <sw-option
                        v-for="item in wmfOpt.unitOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </sw-option>
                    </sw-select>
                </el-col>
              </el-form-item>
            </el-row> -->

          </el-form>
        </el-col>

        <el-col  class="previewRight" :span="12">
          <div class="previewTitle">预览</div>
          <div class="previewContent">
            <div class="box">
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'01'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'02'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'03'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'04'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'05'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'06'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'07'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'08'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'09'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
              <div class="wmfContent" >
                <div class="wmfItem" v-for="(item, index) in pwmc" :key="index +'10'">
                  <div class="textarea">
                    <div class="brItem" v-for="(ele, eIndex) in item.previewValue" :key="eIndex">{{ ele }}&emsp;&emsp;&emsp;&emsp;</div>
                  </div>
                  <div class="date">{{ item.nowTime }}&emsp;&emsp;&emsp;&emsp;</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

      </el-row>

      <div slot="footer">
        <div style="margin-bottom: 10px">
          <sw-button simple @click.stop="wmVisible = false">取消</sw-button>
          <sw-button type="primary" @click="submitForm">确定</sw-button>
        </div>
      </div>
    </sw-dialog>

    <sw-dialog :visible.sync="bdbl.visible" append-to-body width="50%" center title="表单变量查询">
      <sw-input v-model="bdbl.filterValue" placeholder="请输入筛选内容" prefix-icon="el-icon-search" />
      <ul style="padding-left: 0px; overflow: auto; max-height: 300px">
        <li v-for="(item, index) in bdblFilterList" :key="index"
          style="margin: 10px; display: flex; justify-content: space-between">
          <span style="flex: 1">{{ item.name }}</span><span style="flex: 1">{{ item.model }}</span>
        </li>
      </ul>
    </sw-dialog>
  </div>

</template>
<script>
export default {
  name: 'waterMark',
  props: ['waterMarkVisible', 'wmfConfig', 'wmfOpt', 'blList'],
  data () {
    return {
      wmVisible: this.waterMarkVisible,
      form: JSON.parse(JSON.stringify(this.wmfConfig)),
      bdbl: {
        list: this.blList,
        visible: false,
        filterValue: ''
      },
      angleValue: {
        optValue: 45,
        cusValue: this.wmfConfig.rotationAngle ? this.wmfConfig.rotationAngle : 45
      },
      wmObj: {
        previewValue: [],
        nowTime: ''
      },
      pwmc: [],
      // pwmcWidth: '',
      // scaleValue: 0.5, // 计数器绑定的页面比例值
      // defaultScale: 0.5, // 默认页面比例
      markNumValue: 2, // 下拉选择行数绑定值
      defaultMarkNum: 1, // 默认水印行数
      textValue: '' // 水印内容绑定值

    }
  },
  computed: {
    bdblFilterList () {
      const filterArr = this.bdbl.list.filter((item) => {
        const str = item.name + '：' + item.model
        return str.indexOf(this.bdbl.filterValue) > -1
      })
      return filterArr
    }
  },
  watch: {
    wmVisible: {
      handler (val) {
        this.$emit('update:waterMarkVisible', val)
      }
    },
    blList: {
      handler (val) {
        this.bdbl.list = val
      },
      deep: true,
      immediate: true
    },
    wmfConfig: {
      handler (val) {
        let optAngleItem = this.wmfOpt.rotationAngleOptions.find(item => {
          return item.value === val.rotationAngle
        })
        if (optAngleItem) {
          this.angleValue.optValue = optAngleItem.value
        } else {
          this.angleValue.optValue = null
          this.angleValue.cusValue = val.rotationAngle
        }
        if (val.content) {
          this.textValue = val.content.trim().replace('&&', '\n')
        }
        if (val.markNumChecked) {
          this.markNumValue = val.markNumber
        }
      },
      deep: true,
      immediate: true
    },
    'angleValue.optValue': {
      handler (val) {
        if (val === null) {
          this.angleValue.cusValue = this.wmfConfig.rotationAngle
          this.form.rotationAngle = this.wmfConfig.rotationAngle
        } else {
          this.form.rotationAngle = val
        }
      },
      immediate: true
    },
    'angleValue.cusValue': {
      handler (val) {
        if (this.angleValue.optValue === null) {
          this.form.rotationAngle = val
        } else {
          this.form.rotationAngle = this.angleValue.optValue
          this.angleValue.cusValue = this.wmfConfig.rotationAngle
        }
      },
      immediate: true
    },
    textValue: {
      handler (val) {
        if (val) {
          this.form.content = val.trim().replace('\n', '&&')
        }
      }
    },
    markNumValue: {
      handler (val) {
        if (this.form.markNumChecked) {
          this.form.markNumber = val
        }
      }
    },
    'form.markNumChecked': {
      handler (val) {
        if (val) {
          this.form.markNumber = this.markNumValue
        } else {
          this.form.markNumber = this.defaultMarkNum
        }
      }
    },
    form: {
      handler (val) {
        // 水印是否需要下载日期
        this.$nextTick(() => {
          if (val.dateChecked) {
            let time = new Date()
            this.wmObj.nowTime = this.timestampToTime(time.toLocaleString('en-US', { hour12: false }).split(' '))
            // 打印结果格式为：2022-8-31 11:08:34
          } else {
            this.wmObj.nowTime = ''
          }
          this.wmObj.previewValue = this.form.content.split('&&')
          // 设置水印行数
          let num = val.markNumber
          this.pwmc = new Array(num).fill(this.wmObj)
          console.log('this.pwmc', this.pwmc)
          // 水印样式
          let waterMarkDom = document.querySelector('.previewRight .previewContent .box')
          if (waterMarkDom) {
            waterMarkDom.style.fontFamily = val.fontFamily
            waterMarkDom.style.fontSize = val.fontSize * val.pageScale + 'px'
            waterMarkDom.style.color = val.fontColor
            waterMarkDom.style.opacity = val.opacity
            // 水印旋转以及偏移
            let XDistance
            let YDistance
            if (val.horizontalAlignment.unit === 'cm') {
              XDistance = val.horizontalAlignment.alignNumber * 25 + 'px'
            } else if (val.horizontalAlignment.unit === 'mm') {
              XDistance = val.horizontalAlignment.alignNumber * 25 * 0.01 + 'px'
            }
            if (val.horizontalAlignment.unit === 'cm') {
              YDistance = val.verticalAlignment.alignNumber * 25 + 'px'
            } else if (val.horizontalAlignment.unit === 'mm') {
              YDistance = val.verticalAlignment.alignNumber * 25 * 0.01 + 'px'
            }
            let angleFlag = String(val.rotationAngle).includes('-')
            if (angleFlag) {
              waterMarkDom.style.transform = 'rotate(' + Math.abs(this.form.rotationAngle) + 'deg)' + '' + 'scaleX(' + val.pageScale + ')' + '' + 'translate(' + XDistance + ', ' + YDistance + ')'
            } else {
              waterMarkDom.style.transform = 'rotate(' + '-' + Math.abs(this.form.rotationAngle) + 'deg)' + '' + 'scaleX(' + val.pageScale + ')' + '' + 'translate(' + XDistance + ', ' + YDistance + ')'
            }

            waterMarkDom.style.fontSize = val.fontSize * val.pageScale + 'px'

            // // 水印对齐方式
            // let wmfcDom = document.querySelectorAll('.previewRight .previewContent .box .wmfContent')
            // wmfcDom.forEach(item => {
            // // 水平对齐方式
            //   if (val.horizontalAlignment.align === 'left') {
            //     item.style.alignItems = 'flex-start'
            //     item.style.textAlign = 'left'
            //   } else if (val.horizontalAlignment.align === 'center') {
            //     item.style.alignItems = 'center'
            //     item.style.textAlign = 'center'
            //   } else if (val.horizontalAlignment.align === 'right') {
            //     item.style.textAlign = 'right'
            //   }
            // })

            // // 垂直对齐方式
            // let wmfcDomHeight = wmfcDom[0] ? wmfcDom[0].offsetHeight : undefined
            // let wmfiDom = document.querySelectorAll('.previewRight .previewContent .box .wmfContent .wmfItem')
            // let wmfiHeight = wmfiDom[0] ? wmfiDom[0].offsetHeight : undefined
            // let marginSpace
            // if (wmfcDomHeight && wmfiHeight) {
            //   marginSpace = (wmfcDomHeight - num * wmfiHeight) / (num + 1)

            //   wmfiDom.forEach(item => {
            //     if (val.verticalAlignment.align === 'top') {
            //       wmfcDom.forEach(el => {
            //         el.style.justifyContent = 'flex-start'
            //       })
            //       item.style.marginBottom = marginSpace + 'px'
            //       item.style.marginTop = 0 + 'px'
            //     } else if (val.verticalAlignment.align === 'center') {
            //       wmfcDom.forEach(el => {
            //         el.style.justifyContent = 'space-evenly'
            //       })
            //       item.style.marginTop = 0 + 'px'
            //       item.style.marginBottom = 0 + 'px'
            //     } else if (val.verticalAlignment.align === 'bottom') {
            //       wmfcDom.forEach(el => {
            //         el.style.justifyContent = 'flex-end'
            //       })
            //       item.style.marginTop = marginSpace + 'px'
            //       item.style.marginBottom = 0 + 'px'
            //     }
            //   })
            // }
          }
        })

        console.log('form', val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm () {
      console.log('this.form', this.form)
      this.$emit('sendConfig', this.form)
      this.wmVisible = false
    },
    timestampToTime (times) {
      let time = times[1]
      let mdy = times[0]
      mdy = mdy.split('/')
      let month = parseInt(mdy[0])
      let day = parseInt(mdy[1])
      let year = parseInt(mdy[2])
      return year + '-' + month + '-' + day + ' ' + time
    },
    changeColorToRgb (str) {
      var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/
      if (!reg.test(str)) { return }
      // eslint-disable-next-line no-useless-escape
      let newStr = (str.toLowerCase()).replace(/\#/g, '')
      let len = newStr.length
      if (len === 3) {
        let t = ''
        for (let i = 0; i < len; i++) {
          t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1))
        }
        newStr = t
      }
      let arr = [] // 将字符串分隔，两个两个的分隔
      for (let i = 0; i < 6; i = i + 2) {
        let s = newStr.slice(i, i + 2)
        arr.push(parseInt('0x' + s))
      }
      console.log('arr', arr)
      this.form.fontColor = 'rgb(' + arr.join(',') + ')'
      return this.form.fontColor
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
.waterMarkPart{
  display: flex;
  justify-content: space-between;
  .sw-dialog.el-dialog .el-dialog__body{
    min-width: 900px;
    .el-row--flex.is-justify-space-between{
      height: 100%;
    }
  }
}
.formLeft.el-col{
  .el-form.waterMarkForm{
    width: 380px;
    .el-form-item {
      margin-bottom: 2px;
    }
    .mnItem,.pcItem{
      position: relative;
    }
    .mnItem{
      .el-checkbox.positionPart{
        position: absolute;
        z-index: 2;
        top:50%;
        left: 18px;
        transform: translateY(-50%);
      }
    }
    .pcItem{
      .el-checkbox.positionPart{
        position: absolute;
        z-index: 2;
        top:50%;
        left: -10px;
        transform: translateY(-50%);
      }
    }

  }
  .el-row.smallInputNumber{
      .el-input-number--small{
        width: 100%;
        .el-input-number.is-controls-right .el-input__inner{
          padding-right: 45px;
        }
      }
  }
}

.previewRight.el-col{
  flex: 1;
  display: flex;
  flex-direction: column;
  .previewContent{
    border: 1px solid #999999;
    box-sizing: border-box;
    margin-top: 10px;
    margin-left: 20px;
    width: 300px;
    min-height:450px;
    flex: 1;
    position: relative;
    overflow: hidden;
    .box{
      position: absolute;
      height: 100%;
      flex: 1;
      top: 0;
      left:-300px;
      z-index: 1;
      display: flex;
      // transform-origin: (150px center);
      transform-origin: (450px center);
      .wmfContent{
        // width: 300px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content:space-evenly;
        align-items: center;
        white-space: nowrap;
        text-align: left;
        .wmfItem{
          // margin-right: 100px;
          // width: 100%;
          align-items: center;
          .textarea{
            margin-bottom: 2px;
          }
        }
      }
    }
  }
}
</style>
